/** Lịch nghỉ chung của phòng khám. Real /api/v1/clinic/holidays. */
import { apiClient } from "./client";

export interface ClinicHoliday {
  id: string;
  /** null = toàn phòng khám (mọi chi nhánh); có giá trị = riêng chi nhánh đó. */
  branchId: string | null;
  /** ISO yyyy-MM-dd. */
  date: string;
  reason: string | null;
}

export const clinicHolidaysApi = {
  list(): Promise<ClinicHoliday[]> {
    return apiClient.get<ClinicHoliday[]>("/v1/clinic/holidays").then((r) => r.data);
  },
  add(
    date: string,
    reason: string | null,
    branchId: string | null = null,
  ): Promise<ClinicHoliday> {
    return apiClient
      .post<ClinicHoliday>("/v1/clinic/holidays", { date, reason, branchId })
      .then((r) => r.data);
  },
  remove(id: string): Promise<void> {
    return apiClient.delete<void>(`/v1/clinic/holidays/${id}`).then(() => undefined);
  },
};

export const clinicHolidayQueryKeys = {
  all: () => ["clinic-holidays"] as const,
};
